'use es6';

import * as ActionTypes from './ActionTypes';
export const resetProfileReviewFilters = () => ({
  type: ActionTypes.PROFILE_REVIEW_FILTERS_RESET
});
export const updateReviewFilters = updates => ({
  type: ActionTypes.PROFILE_REVIEW_FILTERS_UPDATED,
  payload: updates
});